import { render, staticRenderFns } from "./InputRow.vue?vue&type=template&id=23c50732&"
import script from "./InputRow.vue?vue&type=script&lang=js&"
export * from "./InputRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports